import { MenuItem, styled, TextField, Tooltip } from "@mui/material";
import * as React from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const USB0 = "/dev/serial/by-path/platform-xhci-hcd.5.auto-usb-0:1:1.0-port0";
const USB1 = "/dev/serial/by-path/platform-xhci-hcd.4.auto-usb-0:1:1.0-port0";
const USB2 = "/dev/serial/by-path/platform-fd840000.usb-usb-0:1:1.0-port0";
const USB3 = "/dev/serial/by-path/platform-fd8c0000.usb-usb-0:1:1.0-port0";
const ONLOGIC_SERIAL = "/dev/serial/by-path/platform-fe9c0000.xhci-usb-0:1.1:1.0-port0";

export const portToPathMap = {
  USB0: USB0,
  USB1: USB1,
  USB2: USB2,
  USB3: USB3,
  "ONLOGIC-SERIAL": ONLOGIC_SERIAL,
};

export const pathToIDMap = {
  [USB0]: "USB0",
  [USB1]: "USB1",
  [USB2]: "USB2",
  [USB3]: "USB3",
  [ONLOGIC_SERIAL]: "ONLOGIC-SERIAL",
};

export const pathToPortMap = {
  [USB0]: "USB 0",
  [USB1]: "USB 1",
  [USB2]: "USB 2",
  [USB3]: "USB 3",
  [ONLOGIC_SERIAL]: "ONLOGIC-SERIAL",
};

export default function USBPortSelect({
  value,
  onChange,
  disabled = false,
  tooltipPlacement = "top",
  iconSize = "medium",
  disabledPorts = [],
  ...props
}) {
  const StyledTextField = styled(TextField)({
    "& .MuiFormLabel-root": {
      display: "flex",
      alignItems: "center",
      "& .myIcon": {
        paddingLeft: "8px",
        order: 999,
      },
    },
    paddingTop: 0,
  });

  function InfoLabel() {
    return (
      <>
        Select USB port
        <Tooltip placement={tooltipPlacement} title={"Select the serial port to which the device is connected"}>
          <HelpOutlineIcon className="myIcon" fontSize={iconSize} />
        </Tooltip>
      </>
    );
  }

  const options = [
    { name: "USB 0", value: USB0 },
    { name: "USB 1", value: USB1 },
    {
      name: "USB 2",
      value: USB2,
    },
    { name: "USB 3", value: USB3 },
    { name: "ONLOGIC-SERIAL", value: ONLOGIC_SERIAL },
  ];

  return (
    <StyledTextField
      select
      label={<InfoLabel />}
      disabled={disabled}
      fullWidth
      sx={{ ...props.sx }}
      value={value}
      onChange={onChange}
    >
      {options.map((obj, idx) => (
        <MenuItem key={idx} value={obj.value}>
          {obj.name}
        </MenuItem>
      ))}
    </StyledTextField>
  );
}
